import { useCallback, useEffect, useMemo, useState } from "react";
import { loadBrokerTimeZoneFromApi } from "utils/loadBrokerTimeZone";
import {
  formatTimeInfoWallClock,
  getTimeInfoMeta,
  parseTimeInfoWallClockMs,
  useBrokerTimeZoneId,
} from "utils/dateFormats";

export const TimerAndDate = () => {
  useBrokerTimeZoneId();
  const [wallMs, setWallMs] = useState(0);
  const [timeAbbreviation, setTimeAbbreviation] = useState("");
  const [isRefreshApi, setIsRefreshApi] = useState(true);

  const formattedTime = useMemo(
    () => (wallMs ? formatTimeInfoWallClock(wallMs) : null),
    [wallMs]
  );

  const handleVisibilityChange = useCallback(() => {
    if (document.visibilityState === "visible") {
      setIsRefreshApi(true);
    } else if (document.hidden) {
      setIsRefreshApi(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [handleVisibilityChange]);

  useEffect(() => {
    const meta = getTimeInfoMeta();
    const start = parseTimeInfoWallClockMs(meta.datetime);
    if (start) {
      setWallMs(start);
      setTimeAbbreviation(meta.abbreviation || "");
    }
  }, []);

  useEffect(() => {
    if (!isRefreshApi) return undefined;
    let cancelled = false;
    loadBrokerTimeZoneFromApi()
      .then(() => {
        if (cancelled) return;
        const meta = getTimeInfoMeta();
        const start = parseTimeInfoWallClockMs(meta.datetime);
        if (start) {
          setWallMs(start);
          setTimeAbbreviation(meta.abbreviation || "");
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [isRefreshApi]);

  useEffect(() => {
    if (!isRefreshApi || !wallMs) return undefined;
    const intervalId = setInterval(() => {
      setWallMs((ms) => (ms ? ms + 1000 : ms));
    }, 1000);
    return () => clearInterval(intervalId);
  }, [isRefreshApi, Boolean(wallMs)]);

  return (
    <li className="timing_wrap  d-xl-block">
      {formattedTime?.currentTime && (
        <h4 className="text-white m-0">
          {formattedTime.currentTime} {formattedTime.currentTime && timeAbbreviation}
        </h4>
      )}
      {formattedTime?.currentDate && (
        <h5 className="text-white m-0">{formattedTime.currentDate}</h5>
      )}
    </li>
  );
};
